export default __webpack_public_path__ + "static/media/fleche_mission_verte.4e55c3ac.svg";